/* eslint-disable */

import React from 'react';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

export default class FieldDatePicker extends React.Component {
  state = {
    focused: false,
  };

  onFocusChange = ({ focused }) => {
    this.setState(() => ({ focused }));
  };

  render() {
    const { date, id, onDateChange } = this.props;
    const { focused } = this.state;

    return (
      <SingleDatePicker
        id={id}
        date={date ? moment(date, 'YYYY-MM-DD') : null}
        onDateChange={moment_date => onDateChange(moment_date ? moment_date.format('YYYY-MM-DD') : null)}
        focused={focused}
        onFocusChange={this.onFocusChange}
        isOutsideRange={() => false}
        hideKeyboardShortcutsPanel
        readOnly
      />
    );
  }
}
